import { useState } from "react";
import { FaAngleRight } from "react-icons/fa6";
import walletIcon from "../../../../Images/wallet02.png"; // apna icon lagana
import coinIcon from "../../../../Images/L2E_single_coin.png"; // apna coin icon lagana
import RechargeModal from "../../../../components/Wallet/RechargeModal";
import {useUser} from "../../../..//hooks/use-user/index";
const CreditBalanceCard = () => {
  const [showRecharge, setShowRecharge] = useState(false);
    const { data: User, isLoading, error, refetchUser } = useUser();
console.log(User,"credit Balance card")
  return (
    <>
      <div className="lg:hidden w-full bg-white rounded-3xl p-4 shadow-[0_10px_25px_rgba(0,0,0,0.1)] flex flex-row items-center justify-between gap-6">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <img src={walletIcon} alt="" className="w-6 h-6" />
            <span className="text-gray-700 text-sm font-medium">
              Credit Balance
            </span>
          </div>

          <h2 className="text-2xl sm:text-2xl font-bold text-black">
            {User?.unifiedWallet?.balance || 0}{" "}
            <span className="text-sm text-gray-600">Credits</span>
          </h2>

          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-yellow-100 flex items-center justify-center">
              <img src={coinIcon} alt="" className="w-4 h-4" />
            </div>
            <div className="flex gap-2">
              <p className="text-purple-500 text-sm">Get</p>
              <p className="font-bold text-black">
                100 <span className="text-gray-700">Credits</span>
              </p>
            </div>
          </div>
        </div>

        <div className="flex">
          <button
            onClick={() => setShowRecharge(true)}
            className="flex items-center gap-1 bg-[#34163F] text-white px-4 py-2 rounded-full font-medium shadow-md hover:scale-95 transition"
          >
            Get Credits
            <FaAngleRight />
          </button>
        </div>
      </div>

      <div className="hidden lg:flex w-full bg-white rounded-3xl p-4 min-h-[240px] shadow-[0_18px_45px_rgba(63,63,68,0.08)] border border-gray-100 flex-col justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-full bg-[#F2E8FB] flex items-center justify-center shrink-0">
            <img src={walletIcon} alt="" className="w-6 h-6 object-contain" />
          </div>
          <div className="text-left">
            <span className="text-gray-900 text-sm font-semibold">
              Your Credit Balance
            </span>
            <p className="text-[16px] text-gray-500 mt-0.5">Available rewards</p>
          </div>
        </div>

        <div className="text-left">
          <h2 className="text-2xl font-bold leading-none text-[#171321]">
            {User?.unifiedWallet?.balance || 0}
            <span className="ml-2 align-middle text-base font-semibold text-gray-600">
              Credits
            </span>
          </h2>
        </div>

        <div className="h-px w-full bg-gray-100" />

        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center shrink-0">
            <img src={coinIcon} alt="" className="w-6 h-6 object-contain" />
          </div>
          <div className="text-left">
            <p className="text-sm text-gray-500">Get</p>
            <p className="text-base text-sm font-bold text-[#171321]">
              100 <span className="text-gray-600 font-semibold">Credits</span>
            </p>
          </div>
        </div>

        <button
          onClick={() => setShowRecharge(true)}
          className="flex w-full items-center justify-center gap-3 rounded-2xl bg-gradient-to-r from-[#6E32B7] to-[#34163F] px-5 py-3 text-sm font-semibold text-white shadow-[0_12px_24px_rgba(52,22,63,0.18)] transition hover:scale-[0.98]"
        >
          Get Credits
          <FaAngleRight />
        </button>
      </div>

      {/* ✅ Recharge Modal */}
      {showRecharge && (
        <div className="fixed inset-0 z-50 flex items-end justify-center">
          {/* Backdrop */}
          {/* <div
      className="absolute inset-0 bg-black/40 backdrop-blur-sm"
      onClick={() => setShowRecharge(false)}
    /> */}

          {/* Bottom Sheet */}
          <div className="relative w-full max-w-md rounded-t-3xl p-5 h-[85vh] overflow-y-auto animate-slideUp">
            {/* Drag Handle */}
            <div className="w-12 h-1.5 bg-gray-400 rounded-full mx-auto mb-4"></div>

            {/* Content */}
            <RechargeModal
              isOpen={showRecharge}
              onClose={() => setShowRecharge(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CreditBalanceCard;
